import {
    Card,
    Typography
} from "@mui/material";
import { getAttendanceMeetingUsersByFilter, getAttendanceMeetingUsersPDFAPI } from "api/report";
import ReportFilterCountCard from "app/components/Card/report/ReportFilterCountCard";
import ReportMeetingUsersInfoTable from "app/components/Table/reports/ReportMeetingUsersInfoTable";
import { groupByPropertyName } from "app/utils/appHelpers";
import { useState } from "react";
import { useSelector } from "react-redux";

function ReportMeetingUsersInfoPage({ }) {
    const [data, setData] = useState(null);
    const authUser = useSelector(state => state.auth.authUser);
    const [loading, setLoading] = useState(false);

    const setFilterData = (data) => {
        setData(data);
    };

    const handleResultList = async (state, setState, setLastFilter, setHasData, setLoading) => {
        setLoading(true);
        try {
            const filters = {
                inst: state.inst,
                unitId: state.unitId.map((unit) => unit.id),
                meetingNo: state.meetingNo,
                type: state.type,
                attendanceStatus: state.attendanceStatus,
                userId: authUser.id
            };
            if (filters.attendanceStatus === -1) {
                delete filters.attendanceStatus;
            }
            if (filters.type === -1) {
                delete filters.type;
            }

            const res = await getAttendanceMeetingUsersByFilter(filters);

            setFilterData(res.data);
            setLastFilter(filters);
            setHasData(res.data && res.data.length > 0);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const generatePDF = async (lastFilter, setLoading) => {
        if (!lastFilter) return;
        setLoading(true);
        try {
            await getAttendanceMeetingUsersPDFAPI(
                lastFilter.inst,
                lastFilter.unitId,
                lastFilter.meetingNo,
                lastFilter.type,
                lastFilter.attendanceStatus,
                lastFilter.userId
            );
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    let groupedData = [];
    if (data !== null) {
        const groupedDataObj = groupByPropertyName(data, 'meetingId');
        groupedData = Object.values(groupedDataObj).sort(
            (a, b) => b[0].meetingNo - a[0].meetingNo
        );
    }
    return (
        <div>
            <ReportFilterCountCard
                title={"Üye Katılım Bilgileri"}
                setFilterData={setFilterData}
                onList={handleResultList}
                onGeneratePDF={generatePDF}
                filterType={"user"}
                loading={loading}
                setLoading={setLoading}
            />
            {data !== null && data.length > 0 ? (
                <>
                    <Card sx={{ padding: 2, marginBottom: 1, marginTop: 1, backgroundColor: '#f5f5f5' }}>
                        <Typography variant="h6" align="center" sx={{ fontWeight: 'bold' }}>
                            Toplam Toplantı Sayısı: {groupedData.length}
                        </Typography>
                    </Card>
                    {groupedData.map((group) => (
                        <Card key={group[0].meetingId} sx={{ padding: 2, marginBottom: 2 }}>
                            <ReportMeetingUsersInfoTable data={group} />
                        </Card>
                    ))}
                </>
            ) : (

                (!loading && data !== null) && (<Card sx={{ padding: 2, marginTop: 2 }}>
                    <Typography align="center" variant="h6" sx={{ marginTop: 2 }}>
                        Sonuç Bulunamadı
                    </Typography>
                </Card>)

            )}
        </div>
    );
}
export default ReportMeetingUsersInfoPage;
